"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _LazyLoadWrapper = _interopRequireDefault(require("./LazyLoadWrapper"));

var _Picture = _interopRequireDefault(require("./Picture"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Image = function Image(props) {
  var lazyload = props.lazyload;

  if (lazyload) {
    return /*#__PURE__*/_react.default.createElement(_LazyLoadWrapper.default, {
      lazyload: lazyload
    }, /*#__PURE__*/_react.default.createElement(_Picture.default, props));
  }

  return /*#__PURE__*/_react.default.createElement(_Picture.default, props);
};

Image.propTypes = {
  src: _propTypes.default.oneOfType([_propTypes.default.string, _reactImmutableProptypes.default.map]).isRequired,
  lazyload: _propTypes.default.bool
};
Image.defaultProps = {
  lazyload: true
};
var _default = Image;
exports.default = _default;